import React, { createContext, useEffect, useState } from 'react';
import qs from 'qs';

import themes from 'themes';
import { bastions } from 'constants';
import { getSubdomain } from 'utils';

const BastionContext = createContext({
  bastion: '',
  theme: themes['default'],
});

const OrganizationProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes['default']);
  const [bastion, setBastion] = useState('');

  const getThemeFromOrganizationUrl = () => {
    const query = qs.parse(window.location.search.substring(1));
    const org = query?.org?.toLowerCase();
    const subdomain = getSubdomain(window.location.hostname);
    let currentTheme = 'default';

    if (subdomain) {
      // validate production environment
      let bastion = bastions?.filter((bastion) => subdomain.indexOf(bastion.subdomain) > -1);

      if (bastion?.length === 1) {
        bastion = bastion[0];
        // get bastion theme
        currentTheme = bastion?.theme || 'default';

        const { bastion_slug, theme } = bastion;

        setBastion(bastion_slug);

        if (themes[theme]) setTheme(themes[theme]);
      }

      if (org && themes[org] && currentTheme === 'default') {
        const theme = themes[org];

        setTheme(theme);

        const currentBastion = bastions.find((value) => value.org === org);

        if (currentBastion) {
          setBastion(currentBastion.bastion_slug);
        }
      }
    }
  };

  useEffect(() => {
    getThemeFromOrganizationUrl();
  }, []);

  return <BastionContext.Provider value={{ theme, bastion }}>{children}</BastionContext.Provider>;
};

export default BastionContext;
export { OrganizationProvider };
